import React from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { observer } from 'mobx-react';

import Auth from '../pages/Auth';
import Schedules from '../pages/Schedules';
import ScheduleAssembly from '../pages/ScheduleAssembly';
import SuccessfullyScheduled from '../pages/SuccessfullyScheduled';
import SuccessfullyCanceled from '../pages/SuccessfullyCanceled';
import TrackAssemblyStatus from '../pages/TrackAssemblyStatus';
import NotFound from '../pages/NotFound';
import Error from '../pages/Error';
import ExpiredLinkError from '../pages/ExpiredLinkError';

function Routes() {
  return (
    <Switch>
      <Route path="/auth" component={Auth} />
      <Route path="/agendamentos" component={Schedules} />
      <Route path="/agendar" component={ScheduleAssembly} />
      <Route path="/agendado-com-sucesso" component={SuccessfullyScheduled} />
      <Route path="/cancelado-com-sucesso" component={SuccessfullyCanceled} />
      <Route path="/acompanhamento/:uuid" component={TrackAssemblyStatus} />
      <Route path="/link-expirado" component={ExpiredLinkError} />
      <Route path="/error" component={Error} />
      <Route component={NotFound} />
    </Switch>
  );
}

export default observer(withRouter(Routes));
